module.exports = __webpack_public_path__ + "img/auth.61b5f202.png";